//import ExternalLink from '../../../components/ExternalLink'
import ExternalLink from '../../../components/ExternalLink'
import { Page } from '../../types'

type TricksCVXPYProps = { }
const render = () => {
    return <>
    <h3>Gurobi environments</h3>
    <p>
        Gurobi environment objects can be used to set license information and other parameters at run-time, without relying on a license file. If you
        want to use this functionality with <code>cvxpy</code>, you will need to first initialize an environment using <code>gurobipy</code> and then
        pass this to <code>solve()</code>. This approach is shown in the previous page.
    </p>
    <h3>Passing Gurobi parameters via CVXPY</h3>
    <p>
        If you instantiate a Gurobi environment explicitly in your code, you can set parameters on that object. Otherwise, you should
        pass the parameters as named arguments to <code>solve()</code> in CVXPY. For example, call <code>problem.solve(solver=cp.GUROBI, TimeLimit=60)</code>.
    </p>
    <h3>Performance with Gurobi and CVXPY</h3>
    <p>
        CVXPY performs model transformations behind the scenes when handing over the model to Gurobi. Sometimes these transformations may negatively impact
        performance. Note that different transformations are applied depending on the solver. Please reach out to our Experts team or your Technical Account
        Manager if you face any performance problems.
    </p>
    <p>
        Also, when quadratic problems are involved, CVXPY automatically sets 
        the <ExternalLink href='https://www.gurobi.com/documentation/current/refman/qcpdual.html'>QCPDual</ExternalLink> parameter
        to compute the dual variables of a QCP model. If those duals are not required, then this unnecessarily slows down performance too. That
        last problem can be solved by calling <code>problem.solve(solver=cp.GUROBI, env=env, qcpdual=0)</code>.
    </p>
    <h3>Generating a log file</h3>
    <p>
        By default, CVXPY will not let Gurobi generate logfiles. To create a logfile with name <code>my.log</code>, you need to enable logging
        and pass this filename explicitly using <code>problem.solve(solver=cp.GUROBI, env=env, outputflag=1, logfile='my.log')</code>.
    </p>
    <h3>Exporting a model file</h3>
    <p>
        You can use a Gurobi environment file to tell Gurobi that you want to export the model to a file. This involves creating a text file 
        named <code>gurobi.env</code> in the current working directory for your application (the directory where you launch the process). The 
        file should contain the following line: <pre>GURO_PAR_DUMP 1</pre> Then when you solve a model through CVXPY,
        Gurobi will generate a file called <code>gurobi.mps</code> containing your mathematical model.
    </p>
    </>
}

const TricksCVXPY : Page<TricksCVXPYProps> = { title: 'Tips and tricks for CVXPY', key: 'tricks-cvxpy', render }

export default TricksCVXPY